import React, { useEffect, useRef, useState } from "react";
import playIconGray from "../../images/play_icon_gray.png";
import playIconBlack from "../../images/play_icon_black.png";
import { useNavigate, useParams } from "react-router-dom";
import { useAppContext } from "../../utils/store";
import { apiWrapper } from "../../apis/CommonApi";
import * as fireonApi from "../../apis/FireOnApi";
import fireAlarm01 from '../../audio/alarm_sample01.mp3';
import fireAlarm02 from '../../audio/alarm_sample02.mp3';
import fireAlarm03 from '../../audio/alarm_sample03.mp3';
import fireAlarm04 from '../../audio/alarm_sample04.mp3';
import fireAlarm05 from '../../audio/alarm_sample05.mp3';
import fireAlarm06 from '../../audio/alarm_sample06.mp3';
import PageHeader from "../PageHeader";

export default function FireAlarmSettingComponent() {
  const { store: { id: userId } } = useAppContext();
  const [formData, setFormData] = useState(null);

  useEffect(() => {
    setFormDataProperty("detectorOperation", false);
    setFormDataProperty("accumulatedOperation", false);
    setFormDataProperty("transmitterOperation", false);
    setFormDataProperty("equipmentOutputOperation", false);
    setFormDataProperty("powerFaultAlarm", false);
    setFormDataProperty("controlOperation", false);

    apiWrapper(async () => {
      const { status, data } = await fireonApi.getFireFightingObjectAlarmSetting(userId);
      if (status === true) {
        setFormDataProperty("detectorOperation", data.detectorOperation);
        setFormDataProperty("accumulatedOperation", data.accumulatedOperation);
        setFormDataProperty("transmitterOperation", data.transmitterOperation);
        setFormDataProperty("equipmentOutputOperation", data.equipmentOutputOperation);
        setFormDataProperty("powerFaultAlarm", data.powerFaultAlarm);
        setFormDataProperty("controlOperation", data.controlOperation);
      } else {
        alert(`${data}`);
      }
    });
  }, []);

  const setFormDataProperty = (name, value) => {
    setFormData((currentFormData) => {
      const nextFormData = {
        ...currentFormData,
        [name]: value,
      };
      //console.log(nextFormData);
      return nextFormData;
    });
  };

  const onChange = (e) => {
    let name = e.target.name;
    let value = e.target.checked;
    setFormDataProperty(name, value);

    apiWrapper(async () => {
      const requestBody = {
        "detectorOperation": name === "detectorOperation" ? value : formData.detectorOperation,
        "accumulatedOperation": name === "accumulatedOperation" ? value : formData.accumulatedOperation,
        "transmitterOperation": name === "transmitterOperation" ? value : formData.transmitterOperation,
        "equipmentOutputOperation": name === "equipmentOutputOperation" ? value : formData.equipmentOutputOperation,
        "powerFaultAlarm": name === "powerFaultAlarm" ? value : formData.powerFaultAlarm,
        "controlOperation": name === "controlOperation" ? value : formData.controlOperation
      }

      const { status, data } = await fireonApi.updateFireFightingObjectAlarmSetting(userId, requestBody);
      if (status === false) {
        alert(`${data}`);
      }
    });
  };

  return (
    <section class="mbSection">
      <PageHeader isBlack={false} title="화재경보음" isUseMenu={false} />
      <div class="container pb-per">
        <div class="tableList fireAlarmlist">
          <div class="config-row title-row">
            <div class="title-txt config-title">상태</div>
            <div class="title-txt config-switch">OFF/ON</div>
            <div class="title-txt config-sound">효과음</div>
          </div>
          {formData && (
            <>
              <AlarmRow
                id="detectorOperation"
                name="detectorOperation"
                title="화재 입력회로 감지기 동작 발생"
                checked={formData.detectorOperation}
                audioSrc={fireAlarm01}
                onChange={onChange}
              /><AlarmRow
                id="accumulatedOperation"
                name="accumulatedOperation"
                title="화재 입력회로 축적 동작 발생"
                checked={formData.accumulatedOperation}
                audioSrc={fireAlarm02}
                onChange={onChange}
              /><AlarmRow
                id="transmitterOperation"
                name="transmitterOperation"
                title="화재 입력회로 발신기 동작 발생"
                checked={formData.transmitterOperation}
                audioSrc={fireAlarm03}
                onChange={onChange}
              /><AlarmRow
                id="equipmentOutputOperation"
                name="equipmentOutputOperation"
                title="설비 출력회로 동작 발생"
                checked={formData.equipmentOutputOperation}
                audioSrc={fireAlarm04}
                onChange={onChange}
              /><AlarmRow
                id="powerFaultAlarm"
                name="powerFaultAlarm"
                title="화재수신기 전원/고장 알람 발생"
                checked={formData.powerFaultAlarm}
                audioSrc={fireAlarm05}
                onChange={onChange}
              />
              <AlarmRow
                id="controlOperation"
                name="controlOperation"
                title="화재수신기 제어 동작 발생"
                checked={formData.controlOperation}
                audioSrc={fireAlarm06}
                onChange={onChange}
              />
            </>
          )}
        </div>
      </div>
      <div class="btmBtnWrap">
        <button class="btn btn-grey">취소</button>
        <button class="btn btn-black">저장</button>
      </div>
    </section>
  );
}

const AlarmRow = ({ id, name, title, checked, audioSrc, onChange }) => {
  const [playingId, setPlayingId] = useState(null);
  const audioRef = useRef(null);

  const isPlaying = playingId === id;

  const handlePlay = () => {
    // 재생 중이면 멈추기
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
    }

    if (isPlaying) {
      setPlayingId(null);
    } else {
      const audio = new Audio(audioSrc);
      audio.play();
      audioRef.current = audio;
      setPlayingId(id);

      audio.addEventListener('ended', () => {
        setPlayingId(null);
      });
    }
  }

  return (
    <div class="config-row">
      <div class="config-title">{title}</div>
      <div class="config-switch">
        <label class="switch">
          <input type="checkbox" name={name} checked={checked} onChange={onChange} />
          <span class="slider"></span>
        </label>
      </div>
      <div class="config-sound">
        <div class="sound-status">
          <button
            className={`btn-sound ${isPlaying ? 'playing' : ''}`}
            data-sound={audioSrc}
            onClick={handlePlay}
          >
            <img
              src={isPlaying ? playIconBlack : playIconGray}
              alt={`${isPlaying ? '재생 중 아이콘' : '대기 상태 아이콘'}`}
              class="icon-img"
            />
          </button>
        </div>
      </div>
    </div>
  );
};